module.exports = __webpack_public_path__ + "img/ic_medium_interview.235533ca.svg";